/*
 * Copyright 2026 Sony Corporation
 */

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { loadConfig } from './config';
import './index.css';

const root = createRoot(document.getElementById('root')!);

// Configuration is fetched before the first render so no component has to cope
// with a half-configured client.
loadConfig().then(
  (config) =>
    root.render(
      <StrictMode>
        <App config={config} />
      </StrictMode>
    ),
  (error: Error) => {
    root.render(<pre className="m-8 whitespace-pre-wrap text-red-700">{error.message}</pre>);
  }
);
